import React, { useCallback, useRef } from 'react';
import { AiFillCamera } from 'react-icons/ai';
import { VscClose } from 'react-icons/vsc';
import Webcam from 'react-webcam';

export default function Camera({ setCamOpen, imgSrc, setImgSrc, fileRef, user, devices }: any) {
  const webcamRef = useRef<any>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  function base64toFile(base_data: any, filename: any) {
    let arr = base_data.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    };
    return new File([u8arr], filename, {type:mime});
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    let file = base64toFile(imageSrc, `${user}님 보호구 착용 사진.png`);
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file)
    fileRef.current.files = dataTransfer.files;
    setCamOpen(false);
  }, [webcamRef]);

  return (
    <div className='w-screen h-[calc(100dvh)] relative bg-white overflow-hidden'>
      <p className='absolute md:text-35 text-txtBlack bg-gray-200 w-[67%] rounded-[10px] md:rounded-[25px] top-40 md:top-[100px] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center z-[1000]'>카메라 버튼으로 사진을 촬영하세요.</p>
      <VscClose className='fixed right-10 md:right-[25px] top-27 md:top-[67px] text-23 md:text-100 z-[1000] text-txtBlack bg-gray-200 rounded-full' onClick={() => setCamOpen(false)} />
      <Webcam
        audio={false}
        videoConstraints={{ facingMode: { exact: "environment" } }} // "user" // { exact: "environment" }
        ref={webcamRef}
        screenshotFormat="image/webp"
        className='absoulte w-screen h-[calc(100dvh)] z-[999]' />
      <canvas className='invisible' ref={canvasRef} />
      <img alt='img' src={imgSrc} ref={imgRef} className='invisible' />
      <button
        className='left-[calc(50%-30px)] md:left-[calc(50%-75px)] text-txtBlack w-60 md:w-[150px] bg-gray-200 text-25 md:text-100 rounded-full px-18 py-20 fixed bottom-17 md:bottom-[42px] z-[1000]'
        onClick={capture}><AiFillCamera />
      </button>
    </div>
  );
}


// <Webcam
// audio={false}
// width={360}
// height={740}
// ref={webcamRef}
// screenshotFormat="image/jpeg"
// videoConstraints={videoConstraints}
// className='absoulte w-screen h-screen z-[999]'
// />
